import PARTICIPANT_STATUS from "enums/PARTICIPANT_STATUS";
import SCRIPT_STATUS from "enums/SCRIPT_STATUS";
import SCRIPT_TYPE from "enums/SCRIPT_TYPE";

export default function getScriptColor(
  type: SCRIPT_TYPE,
  status: SCRIPT_STATUS | PARTICIPANT_STATUS | undefined,
  {
    moderatedColor,
    focusGroupColor,
    publishedColor,
    draftColor,
    invitedColor,
    inprogressColor,
    completedColor,
    paidColor,
    defaultColor,
  },
) {
  if (type === SCRIPT_TYPE.MODERATED) {
    return moderatedColor;
  }
  if (type === SCRIPT_TYPE.FOCUS_GROUP) {
    return focusGroupColor;
  }
  if (status === SCRIPT_STATUS.PUBLISHED) {
    return publishedColor;
  }
  if (status === SCRIPT_STATUS.DRAFT) {
    return draftColor;
  }
  if (status === PARTICIPANT_STATUS.INVITED) {
    return invitedColor;
  }
  if (status === PARTICIPANT_STATUS.INPROGESS) {
    return inprogressColor;
  }
  if (status === PARTICIPANT_STATUS.COMPLETED) {
    return completedColor;
  }
  if (status === PARTICIPANT_STATUS.PAID) {
    return paidColor;
  }

  return defaultColor;
}
